export const shanghaiAbout =
  'Побалуйте свои чувства и погрузитесь в очарование Дальнего Востока в соблазнительной и расслабляющей атмосфере, которая отправит ваши мысли на другой конец света. Ресторан Shanghai с традициями более четверти века предложит Вам самые разнообразные блюда китайской кухни, а также лучшие суши в городе! Великолепно оформленные блюда, приготовленные из оригинальных ингредиентов китайскими поварами, перенесут Вас в мир необычайной азиатской культуры. Чтобы сделать ваше удовольствие более полным в нашем ресторане Вы можете найти местный китайский бренди, сакэ и японское пиво.';
export const lavillaAbout =
  'Ресторан La Villa, созданный из тепла песка и свежести морского берега, нежного солнечного дня и приятного бриза, излучает средиземноморский стиль и предлагает Вам красочное гастрономическое путешествие с внимательным обслуживающим персоналом. В меню Вы сможете найти широкий ассортимент блюд. С предложениями наших сотрудников сделайте правильный выбор и насладитесь ароматами, которые пробудят все ваши чувства. Благодаря большому выбору первоклассных морепродуктов, итальянских деликатесов и высококачественного мяса, приготовленного с профессионализмом талантливых поваров, ресторан La Villa оставит даже самых требовательных гостей в восторге!';
export const abstract =
  'Под стенами старинного города, с очаровательным видом на пристань для яхт, расположились два ресторана, которые обеспечивают комфорт и беспрецедентное гастрономическое наслаждение. Наши рестораны -идеальное место для романтических ужинов, семейных встреч и наслаждения компанией друзей в непринужденной атмосфере. Это зависит от того, захочется ли побаловать себя вкусами традиционной средиземноморской кухни в ресторане La Villa или попробовать азиатскую кухню, которая изобилует богатством вкуса, в ресторане Shanghai.';

const restaurants = [
  {
    id: 'shanghai',
    name: 'Ресторан Shanghai',
    background: require('../../../assets/images/food/shanghai/shanghai1.jpeg'),
    about: shanghaiAbout,
    abstract: abstract,
    title: 'Ресторан Shanghai',
    subtitle: 'Chinese & Sushi Cuisine',
    logoMain: require('../../../assets/images/shanghaiLogoSec.png'),
    logo: require('../../../assets/images/shanghaiLogo.png'),
    color: '#0d4255c4',
    gallery: [
      require('../../../assets/images/food/shanghai/shanghai1.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai2.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai3.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai4.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai5.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai6.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai7.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai8.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai9.jpeg'),
    ],
  },
  {
    id: 'lavilla',
    name: 'Ресторан La Villa',
    background: require('../../../assets/images/food/lavilla/lavilla1.jpeg'),
    about: lavillaAbout,
    abstract: abstract,
    title: 'Ресторан La Villa',
    subtitle: 'Mediterranean Cuisine',
    logoMain: require('../../../assets/images/laVillaLogoSec.png'),
    logo: require('../../../assets/images/laVillaLogo.png'),
    color: '#0d4255c4',
    gallery: [
      require('../../../assets/images/food/lavilla/lavilla1.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla2.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla3.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla4.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla5.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla6.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla7.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla8.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla9.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla10.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla11.jpeg'),
    ],
  },
];

export default restaurants;